export default __webpack_public_path__ + "static/media/Privacy-Policy.cd312e6d.webp";